import { Link, useLocation } from 'react-router-dom'
import React, { useState, useContext } from 'react'

import HomeIcon from 'assets/icons/home-icon'
import SidebarHelpIcon from 'assets/icons/sidebar-help'
import SidebarMenuIcon from 'assets/icons/sidebar-menu'
import SidebarMonitoringIcon from 'assets/icons/sidebar-monitoring'
import ReportIcon from 'assets/icons/report-icon'
import SidebarSitesIcon from 'assets/icons/sidebar-sites'
import SidebarUsersIcon from 'assets/icons/sidebar-users'
import SidebarSensitiveSpeciesIcon from 'assets/icons/sidebar-sensitive-species-icon'
import Tooltip from 'components/Tooltip'
import { ProfileContext } from 'providers/profile'
import {
  MONITORING_PATH,
  ROOT_PATH,
  SITES_PATH,
  USERS_PATH,
  REPORTS_PATH,
  SENSITIVE_SPECIES_PATH
} from 'routing/constants'
import { SECRETARIAT_ROLE_ID, RFP_ROLE_ID } from 'constants/roles'
import Logo from 'assets/kba-logo'
import { canManageUsers } from 'utils/rolePermissions'

import {
  MenuIconWrapper,
  SidebarArrowIconWrapper,
  SidebarExpandedHeader,
  SidebarHeaderWrapper,
  SidebarItem,
  SidebarItemText,
  StyledSidebar,
  SidebarWrapper
} from './style'
import { FormattedMessage, useIntl } from 'react-intl'

const renderSidebarItem = (isExpanded, activePath, path, name, label, Icon) => {
  const tooltipXOffset = 16
  const tooltipYOffset = 0
  return (
    <Link data-test='menu-item' style={{ textDecoration: 'none', color: '#202020' }} to={path}>
      {isExpanded ? (
        <SidebarItem isActive={path === activePath}>
          <Icon /> <SidebarItemText data-test='menu-label' isExpanded={isExpanded}><FormattedMessage
            id={name} /></SidebarItemText>
        </SidebarItem>
      ) : (
        <Tooltip
          placement='right'
          trigger={['hover']}
          overlay={{ label }}
          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
        >
          <SidebarItem isActive={path === activePath}>
            <Icon /> <SidebarItemText isExpanded={isExpanded}><FormattedMessage id={name} /></SidebarItemText>
          </SidebarItem>
        </Tooltip>
      )}
    </Link>
  )
}

const SensitiveMenuIcon = () => <SidebarSensitiveSpeciesIcon />

const Sidebar = () => {
  const intl = useIntl()
  const { profile } = useContext(ProfileContext)
  const [isExpanded, setIsExpanded] = useState(false)
  const location = useLocation()
  const toggleSidebar = () => {
    setIsExpanded((s) => {
      return !s
    })
  }

  const MenuIconTooltipXOffset = 0
  const MenuIconTooltipYOffset = 16

  return (
    <StyledSidebar data-test='side-menu' isExpanded={isExpanded}>
      <SidebarWrapper isExpanded={isExpanded}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <SidebarHeaderWrapper isExpanded={isExpanded}>
            {!isExpanded && (
              <div onClick={toggleSidebar} style={{ display: 'flex', justifyContent: 'center' }}>
                <Tooltip
                  placement='bottom'
                  trigger={['hover']}
                  overlay={{ label: 'expand' }}
                  align={{ offset: [MenuIconTooltipXOffset, MenuIconTooltipYOffset] }}
                >
                  <MenuIconWrapper data-test='expand'>
                    <SidebarMenuIcon />
                  </MenuIconWrapper>
                </Tooltip>
              </div>
            )}

            {isExpanded && (
              <SidebarExpandedHeader>
                <Logo height='32px' width='54px' />
                <Tooltip
                  placement='bottom'
                  trigger={['hover']}
                  overlay={{ label: 'collapse' }}
                  align={{ offset: [MenuIconTooltipXOffset, MenuIconTooltipYOffset] }}
                >
                  <SidebarArrowIconWrapper data-test='collapse' onClick={toggleSidebar}>
                    <SidebarMenuIcon />
                  </SidebarArrowIconWrapper>
                </Tooltip>
              </SidebarExpandedHeader>
            )}
          </SidebarHeaderWrapper>

          {renderSidebarItem(
            isExpanded,
            location.pathname,
            ROOT_PATH,
            'home',
            intl.formatMessage({ id: 'home' }),
            HomeIcon
          )}
          {renderSidebarItem(
            isExpanded,
            location.pathname,
            SITES_PATH,
            'sites',
            intl.formatMessage({ id: 'sites' }),
            SidebarSitesIcon
          )}
          {renderSidebarItem(
            isExpanded,
            location.pathname,
            REPORTS_PATH,
            'reports',
            intl.formatMessage({ id: 'reports' }),
            ReportIcon
          )}
          {canManageUsers(profile.Role.id) &&
          renderSidebarItem(
            isExpanded,
            location.pathname,
            USERS_PATH,
            'users',
            intl.formatMessage({ id: 'users' }),
            SidebarUsersIcon
          )}
          {[SECRETARIAT_ROLE_ID, RFP_ROLE_ID].includes(profile.Role.id) &&
          renderSidebarItem(
            isExpanded,
            location.pathname,
            SENSITIVE_SPECIES_PATH,
            'sensitiveSpecies',
            intl.formatMessage({ id: 'sensitiveSpecies', defaultMessage: 'Sensitive site approval' }),
            SensitiveMenuIcon
          )}
          {renderSidebarItem(
            isExpanded,
            location.pathname,
            MONITORING_PATH,
            'monitoring',
            intl.formatMessage({ id: 'monitoring' }),
            SidebarMonitoringIcon
          )}
        </div>

        <div style={{ marginBottom: '8px' }}>
          {renderSidebarItem(
            isExpanded,
            location.pathname,
            '/support',
            'Support',
            intl.formatMessage({ id: 'Support', defaultMessage: 'Support' }),
            SidebarHelpIcon
          )}
        </div>
      </SidebarWrapper>

    </StyledSidebar>
  )
}

export default Sidebar
